import React from 'react';
import classes from './Home10.module.scss';
import { Link } from 'react-router-dom';

const Home10 = () => {
    // スクロール時にトップに移動
    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // Yappliの導入企業ロゴスライダーをCSSで模倣するためのダミー配列
    const dummyLogos = ['SAISON CARD', 'ANA', 'MUFG', 'KIRIN', 'TOYOTA', 'SONY', 'PANASONIC', 'MITSUI'];
    // 無限スクロール用に2倍にする
    const marqueeItems = [...dummyLogos, ...dummyLogos];

    return (
        <div className={classes.root}>
            {/* Header */}
            <header className={classes.header}>
                <div className={classes.logo}>
                    {/* Yappliのロゴ風にテキストで代用。必要に応じて元のSVGに戻す */}
                    <img src="/react-assets/logo-icon.svg" alt="icon" style={{filter: 'grayscale(100%) brightness(0.2)'}} />
                    collabo
                </div>
                <div className={classes.headerRight}>
                    <a href="#download" className={classes.downloadBtn}>資料ダウンロード</a>
                    <div className={classes.hamburger}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
            </header>

            {/* Hero Section */}
            <section className={classes.hero}>
                <div className={classes.heroContent}>
                    <div className={classes.subBrand}>collabo <span>webx</span></div>
                    <h1 className={classes.catchCopy}>
                        新時代のWeb/App構築、<br />
                        すべてを一つの<br />
                        プラットフォームで。
                    </h1>
                    
                    <div className={classes.heroImage}>
                        <img src="/react-assets/app_dev_hero.png" alt="App Development Presentation" />
                    </div>

                    <p className={classes.subCopy}>
                        ノーコード × AI × ヘッドレスCMSで<br />
                        IT運用の新しいカタチを
                    </p>

                    <a href="#more" className={classes.ctaButton}>詳しくはこちら</a>
                </div>
            </section>

            {/* Tabs Section */}
            <div className={classes.tabsWrapper}>
                <div className={classes.tabsScroll}>
                    <div className={`${classes.tab} ${classes.active}`}>アプリ</div>
                    <div className={classes.tab}>Web</div>
                    <div className={classes.tab}>コラボタウン</div>
                    <div className={classes.tab}>モバイルオーダー</div>
                    <div className={classes.tab}>社内システム</div>
                </div>
            </div>

            {/* Client Logo Slider (Social Proof) */}
            <div className={classes.clients}>
                <div className={classes.marquee}>
                    {marqueeItems.map((logo, index) => (
                        <div key={index} className={classes.logoItem}>{logo}</div>
                    ))}
                </div>
            </div>

            {/* Resource Cards Section */}
            <section className={classes.resources}>
                <div className={classes.cardsScroll}>
                    <div className={classes.card}>
                        <div className={classes.cardImage}>
                            {/* 実在するダミー画像を使用 */}
                            <img src="/react-assets/app_dev_feature.png" alt="資料" style={{transform: 'scale(1.5)'}} />
                        </div>
                        <div className={classes.cardBody}>
                            <h3 className={classes.cardTitle}>【資料請求はこちら】<br/>collabo丸わかり資料3点セット</h3>
                        </div>
                    </div>
                    <div className={classes.card}>
                        <div className={classes.cardImage}>
                            {/* スタイルを少しいじって別の画像っぽく見せる */}
                            <img src="/react-assets/app_dev_feature.png" alt="社内アプリ" style={{transform: 'scale(1.2) rotate(-5deg)'}} />
                        </div>
                        <div className={classes.cardBody}>
                            <h3 className={classes.cardTitle}>社内システムならcollabo<br/>社内エンゲージメント向上</h3>
                        </div>
                    </div>
                    <div className={classes.card}>
                        <div className={classes.cardImage}>
                            <img src="/react-assets/app_dev_hero.png" alt="事例" style={{transform: 'scale(1.1) translateY(10%)'}} />
                        </div>
                        <div className={classes.cardBody}>
                            <h3 className={classes.cardTitle}>【導入事例】<br/>売上150%UPを実現した秘訣</h3>
                        </div>
                    </div>
                </div>
            </section>

            {/* Big Metrics Typography */}
            <section className={classes.metrics}>
                <h2 className={classes.statement}>
                    成果につながる、選ばれるアプリ体験<br />
                    <span className={classes.highlight}>約900</span>の実績が支える、<br />
                    進化するプラットフォーム
                </h2>
            </section>

            {/* Features (特長) */}
            <section className={classes.featuresBlock}>
                <div className={classes.sectionHeader}>
                    <h2 className={classes.sectionTitle}>collabo 4つの特長</h2>
                    <p className={classes.sectionSub}>ビジネスを躍進させる、圧倒的な利便性と拡張性</p>
                </div>
                <div className={classes.featuresGrid}>
                    <div className={classes.featureCard}>
                        <div className={classes.featureIcon}>⚡️</div>
                        <h3>ノーコードで高速開発</h3>
                        <p>プログラミング不要で、直感的なUI操作のみで高度なアプリを構築。開発期間とコストを大幅に削減します。</p>
                    </div>
                    <div className={classes.featureCard}>
                        <div className={classes.featureIcon}>🔄</div>
                        <h3>進化し続ける機能</h3>
                        <p>OSのアップデートや最新トレンドに随時対応。常に最新の機能がクラウド経由でプラットフォームに追加されます。</p>
                    </div>
                    <div className={classes.featureCard}>
                        <div className={classes.featureIcon}>📊</div>
                        <h3>データに基づく分析</h3>
                        <p>ユーザーの行動データを可視化するダッシュボードを標準搭載。PDCAを迅速に回し、ビジネスの成果を最大化します。</p>
                    </div>
                    <div className={classes.featureCard}>
                        <div className={classes.featureIcon}>🤝</div>
                        <h3>万全のサポート体制</h3>
                        <p>アプリの企画段階から、リリース後の運用・改善まで。専門のサクセスチームが並走して支援します。</p>
                    </div>
                </div>
            </section>

            {/* News / イベント */}
            <section className={classes.newsBlock}>
                <div className={classes.sectionHeader}>
                    <h2 className={classes.sectionTitle}>お知らせ</h2>
                </div>
                <ul className={classes.newsList}>
                    <li>
                        <span className={classes.date}>2024.04.01</span>
                        <span className={classes.category}>リリース</span>
                        <a href="#news">新機能「コラボAIアシスタント」の提供を開始しました</a>
                    </li>
                    <li>
                        <span className={classes.date}>2024.03.15</span>
                        <span className={classes.category}>イベント</span>
                        <a href="#news">【ウェビナー】DX推進のための社内アプリ活用術（4/20開催）</a>
                    </li>
                    <li>
                        <span className={classes.date}>2024.03.01</span>
                        <span className={classes.category}>お知らせ</span>
                        <a href="#news">導入企業数が500社を突破いたしました</a>
                    </li>
                </ul>
                <div className={classes.newsMore}>
                    <a href="#news">お知らせ一覧へ <span>&rarr;</span></a>
                </div>
            </section>

            {/* Bottom CTA */}
            <section className={classes.bottomCta}>
                <div className={classes.ctaContainer}>
                    <h2>アプリ開発の常識を変える。<br/>まずは資料でご確認ください。</h2>
                    <div className={classes.ctaButtons}>
                        <a href="#download" className={classes.btnPrimary}>無料で資料請求する</a>
                        <a href="#contact" className={classes.btnSecondary}>オンライン相談を予約する</a>
                    </div>
                </div>
            </section>

            {/* Footer */}
            <footer className={classes.footer}>
                <div className={classes.slogan}>mobile tech for all</div>
                
                <div className={classes.footerLinks}>
                    <a href="#company">運営会社</a>
                    <Link to="/privacy">プライバシーポリシー</Link>
                    <a href="#contact">お問い合わせ</a>
                </div>

                <div className={classes.companyInfo}>
                    <div className={classes.name}>コラボ株式会社 (collabo Inc.)</div>
                    <p>
                        〒921-8163<br />
                        石川県金沢市横川7丁目26
                    </p>
                    <p style={{marginTop: '10px'}}>&copy; {new Date().getFullYear()} collabo Inc.</p>
                </div>
            </footer>
        </div>
    );
};

export default Home10;
